import Konva from 'konva';
import InverterStringLine from "./InverterStringLine";
import { getCurrentRoofHeight } from "./getRoofDetails";
import { SC_Input } from '../input/SC_Input';
import { ModulProp } from '../panel/ModulProp';
import { Sol50 } from '../mountsys/Sol50';
import genarateStringLines from "./genarateStringLines";
import { PanelsDrawnAtInvStrings } from '../../store/senAppProjects.action';
import * as _ from 'lodash';
import { collapseIndexForPanelPage } from '../../store/senAppProjects.action';
import { Global } from '../utilities/global';

export default class InverterStringCanvas {

    containerElement: HTMLElement;
    positionElement: HTMLElement;
    stageWidth: number = 0;
    stageHeight: number = 0;
    stage: Konva.Stage;
    stringTree: any[];
    stringLines: InverterStringLine[];
    panelInUse: any[];
    currentString = 0;
    ctxMenu: any;
    mouseIsDown = false;
    drawingEnable = false;
    // Layers
    backgroundLayer: Konva.Layer;
    panelLayer: Konva.Layer;
    stringLayer: Konva.Layer;
    scale: number = 1;
    scaleY: number = 1;
    currentScale: number = 1;
    panelArray: any = {};
    gridScale: number = 100;
    planDetails: any = [];
    planBorderColor: string = "#a1a9c4";
    stringAssoc: any = [];
    panelColorFilled: string = "#44488b";
    backgroundHeight: number = 0;
    reduxStore: any;
    panelDrawn: number = 0;
    panelIndex: any = 0;
    panelsAttrs: any[] = [];
    completedStrLine: any = [];
    curentPanelIndex: number;
    curentGroupOrigin: any = { x: 0, y: 0 };
    allPanelWithGroup: any = {};
    allgroupWithpanel: any = {};
    allPanelRowsWithDetails: any = {};
    circleRadiusValue: number = 0;
    selectedStrLine: string = "";
    removedStrings: any[] = [];
    completedPanelCount: number = 0;
    totalNoOfPanels: number = SC_Input.sInverter.panelCount;
    listOfToolBoxIndex: any = {};
    maxHeight: number = 0;
    maxWidth: number = 0;
    static totalHeight: number;
    static appliedScale: number;
    constructor(store: any) {
        this.reduxStore = store;

    }
    updateStringLines(inv: any) {
        this.stringLines = genarateStringLines(inv, this.stringLayer);
        // console.log(this.stringLines);
        if (Object.keys(this.listOfToolBoxIndex).length == 0) {
            SC_Input.sInverter.subGenerators.forEach((item, index) => {
                item.strings.forEach((lines: any) => {
                    const name = lines.name.toLowerCase()
                    this.listOfToolBoxIndex[name.replace(" ", "_")] = index + 1;
                })
            })
            // console.log(this.listOfToolBoxIndex);
        }
    }
    deleteBind() {
        var container = this.stage.container();
        container.tabIndex = 1;
        container.focus();
        container.addEventListener('keydown', (e: any) => {
            // console.log("deleted")
            if (e.key == "Delete") {
                // console.log("deleted")
                if (this.selectedStrLine)
                    this.deleteSelectedString();
            }
        });
    }
    render(container: string, position: any, planDetails: any) {
        this.planDetails = planDetails;
        this.stageWidth = position.offsetWidth;
        this.stageHeight = position.offsetHeight;
        this.updateScale();
        this.stage = new Konva.Stage({
            container: container,
            width: this.stageWidth,
            height: window.screen.availHeight * 0.78,
            draggable: true,
            x: 40,
            y: 40
        });
        this.stage.on("wheel", (event) => {
            // let wheelEvent: any = event.evt;
            // wheelEvent.preventDefault();
            // let oldScale = this.currentScale;
            // if (wheelEvent.deltaY > 0) {
            //     this.currentScale *= 0.95;
            // } else if (wheelEvent.deltaY < 0) {
            //     this.currentScale *= 1.05;
            // }
            // var pointer = this.stage.getPointerPosition();
            // let scaleDelta = this.currentScale - oldScale;
            // let mouseX = wheelEvent.layerX;
            // let mouseY = wheelEvent.layerY;
            // let offsetX = -(mouseX * scaleDelta);
            // let offsetY = -(mouseY * scaleDelta);
            // this.stage.x(this.stage.x() + offsetX);
            // this.stage.y(this.stage.y() + offsetY);
            // this.stage.scaleX(this.currentScale);
            // this.stage.scaleY(this.currentScale);
            // this.stage.draw();
            event.evt.preventDefault();
            var oldScale = this.stage.scaleX();
            const scaleBy = 1.1;
            var pointer: any = this.stage.getPointerPosition();

            var mousePointTo = {
                x: (pointer.x - this.stage.x()) / oldScale,
                y: (pointer.y - this.stage.y()) / oldScale,
            };

            var newScale = event.evt.deltaY < 0 ? oldScale * scaleBy : oldScale / scaleBy;
            // console.log(newScale)
            this.stage.scale({ x: newScale, y: newScale });

            var newPos = {
                x: pointer.x - mousePointTo.x * newScale,
                y: pointer.y - mousePointTo.y * newScale,
            };
            this.stage.position(newPos);
            this.stage.batchDraw();
        });
        this.deleteBind();
        // this.stage.on('keydown',  (e: any) => {
        //         if (e.key == "Delete") {
        //             this.deleteSelectedString();
        //         }
        // });

        this.initLayers();
        this.initStrings();
        this.fitStageIntoParentContainer()
        this.updateStringLines(SC_Input.sInverter);
        setTimeout(() => {
            this.loadStringsFromDb()
        }, 1000);
        // this.drawPanels();
        // this.resize();
        // adapt the stage on any window resize
        // window.addEventListener('resize', this.resize);
        // container.addEventListener('contextmenu', this.onContextMenu);
        this.zoomFit();
    }

    drawGrid() {
        // console.log("AppCache.invString", AppCache.invString);
        // console.log(this.gridScale);
        let smallScale = Math.round(this.gridScale / 10);
        let grid = '<svg width="' + this.stage.width() + '" height="' + this.stage.height() + '" xmlns="http://www.w3.org/2000/svg">\n' +
            '    <defs>\n' +
            '        <pattern id="smallGrid" width="' + smallScale + '" height="' + smallScale + '" patternUnits="userSpaceOnUse">\n' +
            '            <path d="M ' + smallScale + ' 0 L 0 0 0 ' + smallScale + '" fill="none" stroke="gray" stroke-width="0.5" />\n' +
            '        </pattern>\n' +
            '        <pattern id="grid" width="' + this.gridScale + '" height="' + this.gridScale + '" patternUnits="userSpaceOnUse">\n' +
            '            <rect width="' + this.gridScale + '" height="' + this.gridScale + '" fill="url(#smallGrid)" />\n' +
            '            <path d="M ' + this.gridScale + ' 0 L 0 0 0 ' + this.gridScale + '" fill="none" stroke="gray" stroke-width="1" />\n' +
            '        </pattern>\n' +
            '    </defs>\n' +
            '\n' +
            '    <rect width="100%" height="100%" fill="url(#grid)" />\n' +
            '</svg>';
        let url = 'data:image/svg+xml;base64,' + btoa(grid);
        const canvas = document.getElementById("inverter_canvas_container");
        if (canvas) {
            canvas.style.backgroundImage = "url(" + url + ")";
        }
        let img = new Image();
        img.onload = () => {
            img.width = this.stage.width();
            img.height = this.backgroundHeight;
            let bgImage = new Konva.Image({
                image: img,
            });
            // this.backgroundLayer.removeChildren();
            // this.backgroundLayer.add(bgImage);
            // this.backgroundLayer.draw();
        };
        img.src = url;
    }

    private initLayers() {
        this.backgroundLayer = new Konva.Layer();
        this.stage.add(this.backgroundLayer);
        this.panelLayer = new Konva.Layer();
        this.stage.add(this.panelLayer);
        this.stringLayer = new Konva.Layer();
        this.stage.add(this.stringLayer);
    }

    fitStageIntoParentContainer = () => {
        let startX = 0 / this.scale;
        let startY = 0 / this.scale;
        this.planDetails.forEach((plan: any) => {
            const width = plan.ok.data.roofB / this.scale;
            const height = getCurrentRoofHeight(plan.ok.data.roofA, plan.ok.data.roofD, plan.ok.data.roofShape) / this.scale;
            var rect: any = new Konva.Rect({
                width: width,
                height: height,
                stroke: this.planBorderColor,
                strokeWidth: 2,
                x: startX,
                y: startY,
            });
            // display plan name
            var planHeaderText: any = new Konva.Text({
                x: (width / 2 + startX),
                y: startY - 10,
                text: plan.ok.data.name.toUpperCase(),
                fontSize: 18,
                fontFamily: 'Calibri',
                fill: '#FFF',
            });
            planHeaderText.setX(width / 2 + startX - planHeaderText.getWidth() / 2);
            planHeaderText.setY(startY - planHeaderText.getHeight() / 2);
            // background For text
            var bgText: any = new Konva.Rect({
                width: planHeaderText.getWidth() + 20,
                height: planHeaderText.getHeight() + 10,
                fill: this.planBorderColor,
                x: width / 2 + startX - planHeaderText.getWidth() / 2 - 10,
                y: startY - planHeaderText.getHeight() / 2 - 6,
                cornerRadius: 20
            });

            this.panelLayer.add(rect);
            this.panelLayer.add(bgText);
            this.panelLayer.add(planHeaderText);
            rect.draw();
            bgText.draw();
            planHeaderText.draw()
            this.drawPanels(plan.ok.data.panelRows, startX, startY);
            startY += 50 / this.scale + height;
        });
        this.backgroundHeight = startY;
        // this.stage.heigh
        this.drawGrid();
        // console.log(SC_Input.sInverter.subGenerators)

    };

    loadStringsFromDb() {
        SC_Input.sInverter.subGenerators.forEach((subGen: any) => {
            subGen.strings.forEach((line: any) => {
                if (line.nodes && line.nodes.length > 0) {
                    let idxLine: any;
                    this.stringLines.forEach((strLine: any, index: number) => {
                        if (strLine.string.name == line.name) {
                            // console.log(strLine.string.name , line.name)
                            idxLine = index;
                        }
                    });

                    const n = _.sortBy(line.nodes, 'nodeIndex');
                    // nodeIndex
                    n.forEach((node: any, index: number) => {
                        this.stringLines[idxLine].used++;
                        this.stringLines[idxLine].string.nodes.push(node);
                        const panel = this.allPanelRowsWithDetails[node.panelRowID.toString() + "-" + node.panelIndex.toString()];
                        const name = line.name.toLowerCase();
                        if (panel)
                            this.addToStringOnLoad(panel, name.replace(" ", "_"), node.nodeIndex, line.color);
                    });
                    if (n.length == line.panelCount) this.completedStrLine.push(line.name);
                }
            });
        })
    }
    updateScale() {
        let xMax = 0;
        let yMax = 0;
        this.planDetails.forEach((plan: any) => {
            if (plan.ok.data.roofB > xMax) {
                xMax = plan.ok.data.roofB;
            }
            const h  = getCurrentRoofHeight(plan.ok.data.roofA, plan.ok.data.roofD, plan.ok.data.roofShape);
            if(this.maxHeight < h) this.maxHeight = h;
            if(this.maxWidth < plan.ok.data.roofB) this.maxWidth = plan.ok.data.roofB;
            yMax += h + 50;
        });
        this.scale = (xMax + 150) / this.stageWidth;
        if(this.maxHeight > this.maxWidth) this.scale = (xMax + 150) / ( this.maxWidth+ 200 );
        this.scaleY = (yMax) / this.stageHeight;
        InverterStringCanvas.totalHeight = yMax + 50;
    }

    zoomFit() {
        this.stage.x(30);
        this.stage.y(30);
        let newScale = 0.95;
        // this.panelLayer.scaleX(this.currentScale);
        // this.panelLayer.scaleY(this.currentScale);
        // this.stringLayer.scaleX(this.currentScale);
        // this.stringLayer.scaleY(this.currentScale);
        if(this.maxHeight > this.maxWidth) {
            newScale = screen.availHeight * 0.78 /( this.maxHeight * newScale+ 40 + 100);
        }
        const gap = (this.stage.width()/2 - this.maxWidth * newScale/2)
        this.stage.x(gap && gap > 0 ? gap : 30);
        this.stage.scale({ x: newScale, y: newScale });
        this.stage.draw();
        InverterStringCanvas.appliedScale = newScale;
    }

    drawPanels(panelRows: any, startX: any, startY: any) {
        // this.panelLayer.removeChildren();
        const panels: any = this.panelLayer.find(".panelStrings");
        if (panels)
            panels.forEach((item: any) => {
                item.destroy();
            });
        const panelWidth = (SC_Input.nModWidth / 10) / this.scale;
        const panelHeight = (SC_Input.nModHeight / 10) / this.scale;
        var panelDetails: any[] = [];
        panelRows.forEach((panel: any, index: number) => {
            let count = 0;
            let w = panelWidth;
            let h = panelHeight;
            if (panel.portrait == ModulProp.ORIENTATION_VERTICAL) {
                w = panelWidth
                h = panelHeight;
            } else {
                w = panelHeight;
                h = panelWidth;
            }
            let x = panel.x / this.scale + startX;
            let y = panel.y / this.scale + startY;

            while (count < panel.panelCount) {
                x = (w + Sol50.nHorizontalAbstand / this.scale) * count + panel.x / this.scale + startX;
                count++;
                const a = {x: x, y: y, width: w, height: h, layer: this.panelLayer, idx: panel.id, panelIndex: count, panelRowId: panel.id.toString() + "-" + count.toString()}
                panelDetails.push(a);
                // this.getPanelForStings(x, y, w, h, this.panelLayer, panel.id, count, panel.id.toString() + "-" + count.toString());
            }
        });
        this.getPanelForStings([...panelDetails]);

        this.panelLayer.on('mousemove', (e: any) => {
            this.curentPanelIndex = e.target.index;

            if (this.drawingEnable && this.mouseIsDown) {
                if (e.target.getClassName() == 'Image') {
                    let index: number = e.target.index;
                    if (!this.panelInUse[index]) {
                        if (this.completedPanelCount < this.totalNoOfPanels)
                            this.addToString(index, e.target);
                    } else {

                    }
                }
            }
        });
        this.stage.on('contentMousedown.proto', (eventData) => {
            if (eventData.evt.buttons === 1) {
                // Only activate on left button
                this.mouseIsDown = true;
            }
        });
        this.stage.on('contentMouseup.proto', () => {
            this.mouseIsDown = false;
        });
        this.stage.on('contentMouseleave.proto', () => {
            this.mouseIsDown = false;
        });
        this.stage.on('contentMouseout.proto', () => {
            this.mouseIsDown = false;
        });
    }

    getPanelForStings(panelDetails: any[]) {
        // getPanelForStings(x: number, y: number, width: number, height: number, layer: any, idx: number, panelIndex: number, panelRowId: string) {
        const imageObj = new Image();
        imageObj.onload = () => {
            panelDetails.forEach((p: any)=>{

                const panelmg = new Konva.Image({
                    image: imageObj,
                    width: p.width,
                    height: p.height,
                    x: p.x,
                    y: p.y,
                    name: "panelStrings"
                });
                p.layer.add(panelmg);
                panelmg.setAttr("idx", p.idx);
                panelmg.setAttr("panelIndex", p.panelIndex);
                this.panelIndex++;
                if (panelmg) panelmg.draw();
                this.panelsAttrs.push(panelmg);
                panelmg.on('mouseover', (e: any) => {
                    // console.log("mouseover",e.target.index);
                });
                panelmg.on('mouseenter', (e: any) => {
                    // console.log("mouseenter", e.target.index);
                });
                panelmg.on('mouseup', (e: any) => {
    
                    // console.log(panelmg.getAttrs());
                });
                panelmg.on('drop', (e: any) => {
                    // console.log("drop",e.target.index);
                });
                this.panelArray[panelmg.index] = panelmg;
                this.allPanelRowsWithDetails[p.panelRowId] = panelmg;
            });
        };
        imageObj.src = document.baseURI + '/assets/images/mono.jpg';

    }

    autoDrawStrings(selectedInverter: any) {
        this.clearStrings();
        this.updateStringLines(selectedInverter);
        const panels = this.panelLayer.getChildren().toArray();

        let children: any = [];
        panels.forEach((item: any) => {
            if (item.getClassName() == "Image") {
                children.push(item);
            }
        });
        children.sort((a: any, b: any) => {
            let diff = Math.abs(a.y() - b.y()) * this.scale;
            if (diff < 100) return a.x() - b.x();
            return a.y() - b.y();
        });
        for (let child of children) {
            this.addToString(child.index, child);
        }
    }

    clearStrings() {
        this.stringAssoc = [];
        this.initStrings();

    }


    initStrings() {
        let panelIndex = 0;
        this.panelInUse = [];
        this.currentString = 0;
        this.stringLines = [];
        this.stringTree = [];
        this.stringLayer.removeChildren();
        this.stringLayer.draw();
        this.panelDrawn = 0;
        this.reduxStore.dispatch(PanelsDrawnAtInvStrings({ panelsDrawn: 0 }));
        this.allPanelWithGroup = {};
        this.allgroupWithpanel = {};

    }

    getcurrentString() {
        let gotStrIndex = false;
        this.stringLines.forEach((item, index) => {
            if (item.used < item.panelCount && !gotStrIndex) {
                this.currentString = index;
                gotStrIndex = true;
            }
        });

    }
    addToString(index: number, target: Konva.Node) {
        this.panelDrawn++;
        this.reduxStore.dispatch(PanelsDrawnAtInvStrings({ panelsDrawn: this.panelDrawn }));
        if (this.stringLines.length == 0) {
            this.updateStringLines(SC_Input.sInverter);
        }
        let stringLine = this.stringLines[this.currentString];

        if (stringLine.used + 1 == stringLine.panelCount) {
            this.completedStrLine.push(stringLine.string.name);
        }

        //
        if (stringLine.used >= stringLine.panelCount) {
            this.completedStrLine.push(stringLine.string.name);
            if (this.currentString + 1 < this.stringLines.length) {
                // console.log(stringLine)
                this.currentString++;
                stringLine = this.stringLines[this.currentString];
                if (stringLine.used == stringLine.panelCount) {
                    this.getcurrentString();
                    stringLine = this.stringLines[this.currentString];

                }
            } else {
                // No free string available
                this.getcurrentString();
                stringLine = this.stringLines[this.currentString];
                if (stringLine.used == stringLine.panelCount)
                    return;
            }
        }
        //
        // Symbol scale
        let symbolScale = this.scale; // InverterStringCanvas.calculateSymbolScale(this.scale);
        let centerX, centerY;
        centerX = target.x() + (target.width() / 2);
        centerY = target.y() + (target.height() / 2);
        target.setAttr("fill", this.panelColorFilled);
        stringLine.panelPaints.push(target);
        stringLine.points.push(centerX, centerY);
        stringLine.stringLine.points(stringLine.points);
        // this.stringLayer.add(stringLine.stringLine);
        const r = target.width() < target.height() ? target.width() / 2 : target.height() / 2;
        // Group
        const name = stringLine.string.name.toLowerCase();
        let group = new Konva.Group({
            x: centerX,
            y: centerY,
            draggable: true,
            name: name.replace(" ", "_") + "_group",
            opacity: 1
        });
        // console.log(stringLine.string.name.replace(" ", "_") + "_group")
        group.on("dragstart", () => {
        });
        group.on("dragmove", () => {
            this.moveStrLine(group);
        });

        group.on("click", () => {
            this.showSelected(name.replace(" ", "_"));
        });
        // stringLine.on("click", () => {
        //     this.showSelected(stringLine.string.name.replace(" ", "_"));
        // });

        group.on("dragend", (e: any) => {
            const cX = e.target.getX();
            const cY = e.target.getY();
            this.findPanel(cX, cY, group);
        });
        let circle: any = new Konva.Circle({
            x: 0,
            y: 0,
            radius: r - 1,
            fill: stringLine.stringLine.stroke(),
            stroke: 'black',
            strokeWidth: 0,
            name: name.replace(" ", "_") + "_circle",
        });
        this.circleRadiusValue = r - 1;
        // circle.setRadius(this.circleRadiusValue - 2);
        group.add(circle);
        stringLine.used++;
        stringLine.panels.push(index);
        this.panelInUse[index] = true;

        // Draw numbers
        const num = parseFloat(stringLine.string.name.split(" ")[1])
        let panelNumText = (num).toString() + "/\n" + stringLine.used.toString();
        // let panelNumText = stringLine.string.invID + "." + stringLine.string.id.toString() + "/\n" + stringLine.used.toString();
        let textWidth = 4 * 36;
        let panelNum = new Konva.Text({
            x: 0,// - circle.getRadius() / 2+2,
            y: 0,// - circle.getRadius() / 2+2,
            text: panelNumText,
            fontSize: 34 / symbolScale,
            fontStyle: 'bold',
            fill: '#fff',
            stroke: 'black',
            strokeWidth: 0,
            align: "center",
            name: name.replace(" ", "_") + "_text",
            opacity: 1

        });
        // panelNum.x(0 - (circle.getRadius() * 2 - panelNum.getWidth() ) / 2);
        // panelNum.y(0 - (circle.getRadius() * 2 - panelNum.getWidth() ) / 2);
        // console.log(panelNum.getWidth(), panelNum.getHeight())

        // if (parseFloat(panelNumText.split('/')[0]) < 10) {
        //     panelNum.x(0 - panelNum.getWidth() / 2 + 1);
        // } else {
        //     panelNum.x(0 - panelNum.getWidth() / 2);
        // }
        // panelNum.y(0 - panelNum.getHeight() / 2 + 3);
        panelNum.x(0 - panelNum.getWidth() / 2);
        panelNum.y(0 - panelNum.getHeight() / 2+2);
        group.add(panelNum);
        this.stringLayer.add(group);
        stringLine.paints.push(group);
        this.stringLayer.batchDraw();
        this.stringAssoc.push(index);
        // Global.stringAssoc.push(index);
        this.allPanelWithGroup[index] = group;
        this.allgroupWithpanel[group._id] = target;
        const node = {
            panelRowID: target.getAttrs().idx,
            panelIndex: target.getAttrs().panelIndex,
            nodeIndex: stringLine.used,
        }
        stringLine.string.nodes.push(node)
    }

    addToStringOnLoad(t: any, name: string, count: number, color: string) {
        this.panelDrawn++;
        this.reduxStore.dispatch(PanelsDrawnAtInvStrings({ panelsDrawn: this.panelDrawn }));
        const target = t.getAttrs();
        let stringLine: any = this.stringLayer.find("." + name)[0];

        let symbolScale = this.scale; // InverterStringCanvas.calculateSymbolScale(this.scale);
        let centerX, centerY;
        centerX = target.x + (target.width / 2);
        centerY = target.y + (target.height / 2);
        const r = target.width < target.height ? target.width / 2 : target.height / 2;
        stringLine.points([...stringLine.points(), centerX, centerY]);
        stringLine.setStroke(color);
        // Group
        let group = new Konva.Group({
            x: centerX,
            y: centerY,
            draggable: true,
            name: name + "_group",
            opacity: 1
        });

        group.on("dragstart", () => {
        });
        group.on("dragmove", () => {
            this.moveStrLine(group);
        });
        group.on("dragend", (e: any) => {
            const cX = e.target.getX();
            const cY = e.target.getY();
            this.findPanel(cX, cY, group);
        });
        let circle: any = new Konva.Circle({
            x: 0,
            y: 0,
            radius: r - 1,
            fill: color, // stringLine.stringLine.stroke(),
            stroke: 'black',
            strokeWidth: 0,
            name: name + "_circle",
        });
        this.circleRadiusValue = r - 1;
        // circle.setRadius(this.circleRadiusValue - 1);
        group.add(circle);
        group.on("click", () => {
            this.showSelected(name);
        });
        stringLine.on("click", () => {
            this.showSelected(name);
        });

        // Draw numbers
        const num = parseFloat(name.split("_")[1])
        let panelNumText = (num).toString() + "/\n" + count.toString();
        let textWidth = 4 * 36;
        let panelNum = new Konva.Text({
            x: 0, // - circle.getRadius() / 2 +2,
            y: 0, // - circle.getRadius() / 2+2,
            text: panelNumText,
            fontSize: 34 / symbolScale,
            fontStyle: 'bold',
            fill: '#fff',
            stroke: 'black',
            strokeWidth: 0,
            align: "center",
            name: name + "_text",
            opacity: 1
        });

        // if (parseFloat(panelNumText.split('/')[0]) < 10) {
        //     panelNum.x(0 - panelNum.getWidth() / 2 + 1);
        // } else {
        //     panelNum.x(0 - panelNum.getWidth() / 2);
        // }
        // panelNum.y(0 - panelNum.getHeight() / 2 + 3);

        panelNum.x(0 - panelNum.getWidth() / 2);
        panelNum.y(0 - panelNum.getHeight() / 2+2);
        group.add(panelNum);
        this.stringAssoc.push(t.index);
        this.panelInUse[t.index] = true;
        this.stringLayer.add(group);
        this.stringLayer.batchDraw();
        this.allPanelWithGroup[t.index] = group;
        this.allgroupWithpanel[group._id] = t;
        const node = {
            panelRowID: target.idx,
            panelIndex: target.panelIndex,
            nodeIndex: count,
        }
    }

    showSelected(name: string) {
        // console.log(this.listOfToolBoxIndex, name);
        this.reduxStore.dispatch(collapseIndexForPanelPage({ collapseIndex: this.listOfToolBoxIndex[name] }));
        this.selectedStrLine = name;
        const list: any = this.stringLayer.find("Text");
        list.forEach((t: any) => {
            t.setOpacity(0.7);
        });
        const listCircle: any = this.stringLayer.find("Circle");
        listCircle.forEach((t: any) => {
            if (t.getName() == name + "_circle") {
                t.setRadius(this.circleRadiusValue);
            } else {
                t.setRadius(this.circleRadiusValue - 1);
            }
        });
        const selectedList: any = this.stringLayer.find("." + name + "_text");
        selectedList.forEach((t: any) => {
            t.setOpacity(1);
        });
        this.stringLayer.draw();
    }

    deleteSelectedString() {
        // console.log(this.completedStrLine,this.selectedStrLine);
        this.completedStrLine.forEach((names: any, index: number) => {
            if (names.toLowerCase() == this.selectedStrLine.replace("_", " ")) {
                this.completedStrLine[index] = "";
            }
        });
        const line: any = this.stringLayer.find("." + this.selectedStrLine);
        line.forEach((l: any) => {
            l.setPoints([]);
        });
        this.stringLayer.draw();
        const list: any = this.stringLayer.find("." + this.selectedStrLine + "_group");
        const noOfNOdes = list.length;
        list.forEach((t: any) => {
            const p = this.allgroupWithpanel[t._id];
            if (p && p._id) {
                this.panelInUse[p.index] = false;
                this.allPanelWithGroup[p.index] = null;
                // this.panelInUse[p.index] = false;
            }
            this.allgroupWithpanel[t._id] = null;
            t.destroy();

        });
        this.stringLines.forEach((line) => {
            if (line.string.name.toLowerCase() == this.selectedStrLine.replace("_", " ")) {
                line.used = 0;
                line.points = [];
                line.string.nodes = [];
                this.panelDrawn -= noOfNOdes;
                this.reduxStore.dispatch(PanelsDrawnAtInvStrings({ panelsDrawn: this.completedPanelCount - noOfNOdes }));
            }
        });
        this.removedStrings.push(this.selectedStrLine);
        this.selectedStrLine = "";
        this.stringLayer.draw();

    }
    drawingEnabled() {
        this.drawingEnable = !this.drawingEnable;
    }

    findPanel(cX: number, cY: number, group: any) {
        let onPanel = false;

        this.panelsAttrs.forEach((item: any) => {
            const a = item.getAttrs();
            if (cX > a.x && cX < (a.x + a.width)) {
                if (cY > a.y && cY < (a.y + a.height)) {
                    onPanel = true;
                    const str = Global.stringName.toLowerCase() + "_" + group.getChildren()[1].textArr[0].text.replace("/", "");
                    const line: any = this.stringLayer.find("." + str)[0];
                    const pointx = a.x + a.width / 2;
                    const pointy = a.y + a.height / 2;
                    const indexStart = (parseInt(group.getChildren()[1].textArr[1].text) - 1) * 2;
                    const points = line.getPoints();
                    points[indexStart] = pointx;
                    points[indexStart + 1] = pointy;
                    line.setPoints(points)
                    group.setX(pointx);
                    group.setY(pointy);

                    const group2 = this.allPanelWithGroup[item.index];
                    if (group2) {


                        const str2 = Global.stringName.toLowerCase() + "_" + group2.getChildren()[1].textArr[0].text.replace("/", "");
                        const line2: any = this.stringLayer.find("." + str2)[0];
                        const panel = this.allgroupWithpanel[group._id];
                        const b = panel.getAttrs();
                        group2.setX(b.x + b.width / 2);
                        group2.setY(b.y + b.height / 2);
                        const indexStart2 = (parseInt(group2.getChildren()[1].textArr[1].text) - 1) * 2;
                        const points2 = line2.getPoints();
                        points2[indexStart2] = b.x + b.width / 2;
                        points2[indexStart2 + 1] = b.y + b.height / 2;
                        line2.setPoints(points2);
                        this.stringLayer.draw();
                        this.allPanelWithGroup[item.index] = group;
                        this.allgroupWithpanel[group._id] = item;
                        this.allPanelWithGroup[panel.index] = group2;
                        this.allgroupWithpanel[group2._id] = panel;
                        let node1: any, node2: any, p1: any, p2: any;
                        const i1 = parseInt(group.getChildren()[1].textArr[1].text);
                        const i2 = parseInt(group2.getChildren()[1].textArr[1].text);
                        this.stringLines.forEach((strLine: any, index: number) => {
                            const namestr = strLine.string.name.toLowerCase();
                            if (namestr == str.replace("_", " ")) {
                                node1 = { ...strLine.string.nodes[i1 - 1] };
                                p1 = index;
                            }
                            if (namestr == str2.replace("_", " ")) {
                                node2 = { ...strLine.string.nodes[i2 - 1] };
                                p2 = index;
                            }
                            if (this.stringLines.length == index + 1) {
                                if (this.stringLines[p1].string.nodes[i1 - 1]) this.stringLines[p1].string.nodes[i1 - 1].panelIndex = node2.panelIndex;
                                if (this.stringLines[p1].string.nodes[i1 - 1]) this.stringLines[p1].string.nodes[i1 - 1].panelRowID = node2.panelRowID;
                                if (this.stringLines[p2].string.nodes[i2 - 1]) this.stringLines[p2].string.nodes[i2 - 1].panelIndex = node1.panelIndex;
                                if (this.stringLines[p2].string.nodes[i2 - 1]) this.stringLines[p2].string.nodes[i2 - 1].panelRowID = node1.panelRowID;
                            }
                        });
                    } else {
                        // const str2 = "string_" + group2.getChildren()[1].textArr[0].text.replace("/", "");
                        // const line2: any = this.stringLayer.find("." + str2)[0];
                        const panel = this.allgroupWithpanel[group._id];
                        const b = panel.getAttrs();
                        // group2.setX(b.x + b.width / 2);
                        // group2.setY(b.y + b.height / 2);
                        // const indexStart2 = (parseInt(group2.getChildren()[1].textArr[1].text) - 1) * 2;
                        // const points2 = line2.getPoints();
                        // points2[indexStart2] = b.x + b.width / 2;
                        // points2[indexStart2 + 1] = b.y + b.height / 2;
                        // line2.setPoints(points2);
                        this.stringLayer.draw();
                        this.allPanelWithGroup[item.index] = group;
                        this.allgroupWithpanel[group._id] = item;
                        this.allPanelWithGroup[panel.index] = null;
                        // this.allgroupWithpanel[group2._id] = panel;
                        let node1: any, node2: any, p1: any, p2: any;
                        const i1 = parseInt(group.getChildren()[1].textArr[1].text);
                        // const i2 = parseInt(group2.getChildren()[1].textArr[1].text);
                        this.stringLines.forEach((strLine: any, index: number) => {
                            const namestr = strLine.string.name.toLowerCase();
                            if (namestr == str.replace("_", " ")) {
                                node1 = { ...strLine.string.nodes[i1 - 1] };
                                p1 = index;
                            }
                            // if (strLine.string.name == str2.replace("_", " ")) {
                            //     node2 = { ...strLine.string.nodes[i2 - 1] };
                            //     p2 = index;
                            // }
                            if (this.stringLines.length == index + 1) {
                                this.stringLines[p1].string.nodes[i1 - 1].panelIndex = node1.panelIndex;
                                this.stringLines[p1].string.nodes[i1 - 1].panelRowID = node1.panelRowID;
                                // this.stringLines[p2].string.nodes[i2 - 1].panelIndex = node1.panelIndex;
                                // this.stringLines[p2].string.nodes[i2 - 1].panelRowID = node1.panelRowID;
                            }
                        });
                    }

                }
            }
        });
        if (!onPanel) {
            const panel = this.allgroupWithpanel[group._id];
            const a = panel.getAttrs()
            const pointx = a.x + a.width / 2;
            const pointy = a.y + a.height / 2;
            group.setX(pointx);
            group.setY(pointy);
            const str = Global.stringName.toLowerCase() + "_" + group.getChildren()[1].textArr[0].text.replace("/", "");
            const line: any = this.stringLayer.find("." + str)[0];

            const indexStart = (parseInt(group.getChildren()[1].textArr[1].text) - 1) * 2;
            const points = line.getPoints();
            points[indexStart] = pointx;
            points[indexStart + 1] = pointy;
            line.setPoints(points)
            this.stringLayer.draw()
        }
    }

    moveStrLine(group: any) {
        const str = Global.stringName.toLowerCase() + "_" + group.getChildren()[1].textArr[0].text.replace("/", "");
        const line: any = this.stringLayer.find("." + str)[0];
        const indexStart = (parseInt(group.getChildren()[1].textArr[1].text) - 1) * 2;
        const points = line.getPoints();
        points[indexStart] = group.getX();
        points[indexStart + 1] = group.getY();
        line.setPoints(points);
    }
}
